<template>
  <ul class="flex flex-col space-y-6">
    <Site
      v-for="site in vacancyStore.sites"
      :key="site.id"
      :site="site"
      class="bg-white shadow-sm sm:rounded-md"
    />
  </ul>
  <div v-if="vacancyStore.sites.length">
    <TwoColumnFormDivider />
    <SocialCampaigns />
    <Jobmarketing />
  </div>

  <FormSave
    :validationErrors="v$.$errors"
    :validationTouch="v$.$touch"
    storeAction="savePublications"
    storeName="vacancy"
  />
</template>

<script setup>
import Site from './Site.vue'
import FormSave from '../FormSave.vue'
import SocialCampaigns from './SocialCampaigns.vue'
import Jobmarketing from './Jobmarketing.vue'
import { useVacancyStore } from '../../store/vacancyStore'
import TwoColumnFormDivider from '../TwoColumnFormDivider.vue'
import { useVuelidate } from '@vuelidate/core'
import { useRoute } from 'vue-router'
import { watch } from 'vue'
import { onUnmounted } from 'vue'

const vacancyStore = useVacancyStore()
const route = useRoute()
const v$ = useVuelidate()

vacancyStore.loadPromotions(route.params.id)
if (vacancyStore.vacancy.id) {
  vacancyStore.loadPublications(route.params.id)
}

watch(
  () => vacancyStore.vacancy,
  () => {
    // We need to have the vacancy first to get the available sites
    vacancyStore.loadPublications(route.params.id)
  },
  { once: true },
)

onUnmounted(() => {
  vacancyStore.errors = []
})
</script>
